import { controls } from "../../controls";

const rp953 = {
  label: "Annexure II",
  pageLabel: "Annexure II",
  starting: true,
  url: "rp953",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "From Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),

    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({tab: "filter",label: "To Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
        
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2"}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "Details of securities transactions for which title is not with the bank",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr. No.",
        accessor: "Sr_No.",
        width:20,
        rwidth:"*"
      },
      {
        Header: "Category",
        accessor: "Category",
        width: 200,
        rwidth: 200
      },
      {
        Header: "Date of Transaction",
        accessor: "Date_of_Transaction",
        type:"date",
        width:"*",
        rwidth:"*"
      },
      {
        Header: "Counter Party",
        accessor: "Counter_Party",
        width:"*",
        rwidth:"*"
      },
      {
        Header: "Name of the Broker",
        accessor: "Name_of_the_Broker",
        width:150,
        rwidth:100
      },
      {
        Header: "Date of Payment",
        accessor: "Date_of_Payment",
        type:"date",
        width:"*",
        rwidth:"*"
      },
      {
        Header: "Amount",
        accessor: "Amount",
        type:"currency",
        width:"*",
        rwidth:"*"
      },
      {
        Header: "Remark Reasons/Status of securities not transfered",
        accessor: "Remark_Reasons",
        width:"*",
        rwidth:"*"
      }
            
    ]
  }
};

export default rp953;